import * as React from 'react';

import { ModalWindow } from '@cian/ui-kit/modal';

import * as styles from './ModalConfirm.css';

export interface IProps {
  onClose(): void;
  isVisible: boolean;
  text: string;
  footer?: React.ReactNode;
  children?: React.ReactNode;
}

export function ModalConfirm({ onClose, isVisible, text, children, footer }: IProps) {
  return (
    <ModalWindow
      fixed={false}
      content={
        <React.Fragment>
          <div className={styles['text']}>{text}</div>
          {children}
        </React.Fragment>
      }
      footer={<div className={styles['footer']}>{footer}</div>}
      size="XS"
      width={450}
      onClose={onClose}
      open={isVisible}
    />
  );
}
